export default "__VITE_ASSET__BO6xU37___"